export default __webpack_public_path__ + "0abe2a3e8b0dea920a291c963ae40f5e.svg";